/*=========================================================================================
  File Name: moduleConsultationState.js
  Description: Consultation Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  consultations: []
}
